export default class BulkEditController {
    /** @ngInject */
    constructor(ThingsApi, selectedThings, DialogService) {
        this.ThingsApi = ThingsApi;
        this.selectedThings = selectedThings;
        this.DialogService = DialogService;

        this.selectedFolderId = null;

        this.editAllWarning = this.selectedThings.isQuery;
    }

    acceptWarning() {
        this.editAllWarning = false;
    }

    declineWarning() {
        this.cancel();
    }

    cancel() {
        this.DialogService.cancel();
    }

    onFolderChange(folderId) {
        this.selectedFolderId = folderId;
    }

    // onLabelsAdded(ev) {
    //     console.log(ev);
    // }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/things-toolbox/bulk-edit/bulk-edit.controller.js